import { Space } from "antd";
import {
  getSentenceIndicesForToken,
  getSentenceIndicesFromTokenToEnd,
  parsedToWordTokens,
  removeEmoFromTokens,
  setEmoOnTokens,
  wordTokensToScript,
  type WordToken,
} from "../../../../helpers/scriptHelpers";
import { useMemo, useState } from "react";
import { NarrationText } from "../NarrationText";
import { EmotionPopover } from "./EmotionPopover";
import { parseScript } from "pages/media/helpers/scriptAnchors/";

export const Emotions = ({
  script,
  onChange,
  isRTL = false,
  language,
}: {
  script: string;
  onChange: (script: string) => void;
  isRTL?: boolean;
  language?: string;
}) => {
  const originalParsed = useMemo(() => parseScript(script), [script]);
  const [tokens, setTokens] = useState<WordToken[]>(() =>
    parsedToWordTokens(originalParsed, language)
  );

  const [openTokenIdx, setOpenTokenIdx] = useState<number | null>(null);

  const handleSave = (newTokens: WordToken[]) => {
    const result = wordTokensToScript(newTokens, originalParsed);
    onChange(result);
  };

  const handleRemove = (tokenIdx: number) => {
    const { start, end } = getSentenceIndicesForToken(tokens, tokenIdx);
    const newTokens = removeEmoFromTokens(tokens, start, end);
    setTokens(newTokens);
    handleSave(newTokens);
    setOpenTokenIdx(null);
  };

  const handleEdit = (
    tokenIdx: number,
    emoId: string,
    currentEmoId: string | undefined
  ) => {
    const { start, end } = currentEmoId
      ? getSentenceIndicesForToken(tokens, tokenIdx)
      : getSentenceIndicesFromTokenToEnd(tokens, tokenIdx);
    const newTokens = setEmoOnTokens(tokens, start, end, emoId);
    setTokens(newTokens);
    handleSave(newTokens);
    setOpenTokenIdx(null);
  };

  return (
    <Space direction="vertical" size="middle">
      <NarrationText $isRTL={isRTL}>
        {tokens.map((token, tokenIdx) => (
          <span key={token.index}>
            <EmotionPopover
              tokenIdx={tokenIdx}
              tokens={tokens}
              isOpen={openTokenIdx === tokenIdx}
              onOpenChange={(open) => setOpenTokenIdx(open ? tokenIdx : null)}
              onEdit={handleEdit}
              onRemove={handleRemove}
            />
          </span>
        ))}
      </NarrationText>
    </Space>
  );
};
